import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.trackEvent(['Open', 'SiteInteraction:AccountNotExists']);
    }

    render({ close, routeTo, user }) {
        return (
            <account-not-exists-modal>
                <dialog-header>
                    <button onClick={close}>×</button>
                </dialog-header>
                <dialog-content>
                    <div>
                        <h2 className='title'>Sorry, but that account doesn't yet exist.</h2>
                        <p className='subtitle'>
                            Would you like to <strong>create an account now</strong> with these credentials?
                        </p>

                        <div className='credentials'>
                            <div className='subtitle'>
                                <span className='label'>Email:  </span>
                                <span className='value'>{user.email}</span>
                            </div>
                            <div className='subtitle'>
                                <span className='label'>Password:  </span>
                                <span className='value'>{'•'.repeat(10)}</span>
                            </div>
                        </div>

                        <div className='links'>
                            <button
                                className='button button-primary create-account-btn'
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.trackClick('SiteInteraction:AccountNotExists_CreateAccount');
                                    routeTo('signup');
                                }}
                            >
                                Create account
                            </button>

                            <a
                                href='#'
                                className='nevermind'
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.trackClick('SiteInteraction:AccountNotExists_Nevermind');
                                    this.clearUserCredentials();
                                    routeTo('login');
                                }}
                            >
                                Nevermind
                            </a>
                        </div>
                    </div>
                </dialog-content>
            </account-not-exists-modal>
        );
    }

    trackClick = (info) => {
        this.props.trackEvent(['Click', info]);
    }

    clearUserCredentials = () => {
        this.props.userUpdate({
            email: '',
            password: '',
        });
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    routeTo: (payload) => dispatch({ type: 'route:to', payload: payload }),
    userUpdate: (payload) => dispatch({ type: 'user:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
